import {useCallback} from "react";

import {hitGTMEcommerceRemoveFromCart} from "../../offer/tracking/ecommerce_events/hit_gtm_ecommerce_remove_from_cart";
import {useAppSelector} from "../../store/hooks";
import {gtmStepApplicationClose} from "../../tracking/google_tag_manager/gtm_event_step_application_close";
import {useLeadData} from "./use_lead_data";
import {useLeadRequiredParams} from "./use_lead_required_params";

export function useLeadFormCloseTracking(handleModalClose: (forceClose?: boolean) => void) {
    const {vendorId, offerId, propertyId} = useLeadRequiredParams();
    const applicationData = useLeadData({vendorId, offerId: offerId || undefined, propertyId: propertyId || undefined});
    const viewType = useAppSelector((state) => state.viewType.current);
    const mainLeadType = useAppSelector((state) => state.mainLead.mainLeadType);
    const sourceSection = useAppSelector((state) => state.mainLead.sourceSection);
    const customSourceSection = useAppSelector((state) => state.mainLead.customSourceSection);

    const resolvedSourceSection = customSourceSection || sourceSection;

    return useCallback(
        (forceClose?: boolean) => {
            if (mainLeadType && applicationData) {
                gtmStepApplicationClose(mainLeadType);

                if (resolvedSourceSection) {
                    hitGTMEcommerceRemoveFromCart({
                        data: applicationData,
                        viewType,
                        leadType: mainLeadType,
                        sourceSection: resolvedSourceSection
                    });
                }
            }

            handleModalClose(forceClose);
        },
        [mainLeadType, applicationData, viewType, sourceSection, customSourceSection, handleModalClose]
    );
}
import {useCallback} from "react";

import {hitGTMEcommerceRemoveFromCart} from "../../offer/tracking/ecommerce_events/hit_gtm_ecommerce_remove_from_cart";
import {useAppSelector} from "../../store/hooks";
import {gtmStepApplicationClose} from "../../tracking/google_tag_manager/gtm_event_step_application_close";
import {useLeadData} from "./use_lead_data";
import {useLeadRequiredParams} from "./use_lead_required_params";

export function useLeadFormCloseTracking(handleModalClose: (forceClose?: boolean) => void) {
    const {vendorId, offerId, propertyId} = useLeadRequiredParams();
    const applicationData = useLeadData({vendorId, offerId: offerId || undefined, propertyId: propertyId || undefined});
    const viewType = useAppSelector((state) => state.viewType.current);
    const mainLeadType = useAppSelector((state) => state.mainLead.mainLeadType);
    const sourceSection = useAppSelector((state) => state.mainLead.sourceSection);
    const customSourceSection = useAppSelector((state) => state.mainLead.customSourceSection);

    const resolvedSourceSection = customSourceSection || sourceSection;

    return useCallback(
        (forceClose?: boolean) => {
            if (mainLeadType && applicationData) {
                gtmStepApplicationClose(mainLeadType);

                if (resolvedSourceSection) {
                    hitGTMEcommerceRemoveFromCart({
                        data: applicationData,
                        viewType,
                        leadType: mainLeadType,
                        sourceSection: resolvedSourceSection
                    });
                }
            }

            handleModalClose(forceClose);
        },
        [mainLeadType, applicationData, viewType, sourceSection, customSourceSection, handleModalClose]
    );
}
